export default defineNuxtPlugin(() => {
    return {
        provide: {
            apiUrl: () => {
                // const cfg = useRuntimeConfig()
                // return import.meta.server ? cfg.app.apiServerURL : cfg.app.apiURL
                return ''
            }
        }
    }
})
